import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { NeedStatus, type NeedDto } from "../../autogen/bff-api";

export const NeedDecisionComment = ({
  need,
  mb,
}: {
  need: Pick<NeedDto, "status" | "decisionComment">;
  mb?: string;
}) => {
  const { t } = useTranslation();
  if (!need.decisionComment) return null;
  const sentBack = need.status === NeedStatus.SentBack;
  if (!sentBack && need.status !== NeedStatus.Rejected) return null;

  return (
    <Alert status={sentBack ? "warning" : "error"} rounded="xl" alignItems="flex-start" mb={mb}>
      <AlertIcon />
      <Box>
        <AlertTitle fontSize="sm">
          {sentBack ? t("Sent back for correction") : t("Reason for rejecting")}
        </AlertTitle>
        <AlertDescription>
          <Text fontSize="sm" whiteSpace="pre-wrap">
            {need.decisionComment}
          </Text>
          {sentBack && (
            <Text fontSize="sm" mt="2" color="smMuted">
              {t("Correct the need and report it again.")}
            </Text>
          )}
        </AlertDescription>
      </Box>
    </Alert>
  );
};
